<template>
    <div class="af">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
                <div class="formDiv flex">
                    <el-form-item class="form-title" prop="gsname" :label="$t('form_company')" >
                        <el-select v-model="formData.gsname" placeholder="请选择公司" @change="changeCompany" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="item in companyName"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
<!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="bmname" label="领用部门" >
                        <el-select v-model="formData.bmname" :placeholder="$t('form_please_select_department')" @change="changeGroup" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="itembm in groupName"
                                    :key="itembm.i_id"
                                    :label="itembm.vc_name"
                                    :value="itembm.i_id">
<!--                                <span  style="display: inline-block;width: 100%">{{itembm.vc_name}}</span>-->
                            </el-option>

                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="sqName" label="申请人" >
                        <el-select v-model="formData.sqName" :placeholder="$t('form_please_select_the_applicant')" @change="changePerson" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="itemsq in personName"
                                    :key="itemsq.i_id"
                                    :label="itemsq.vc_name"
                                    :value="itemsq.i_id">
<!--                                <span style="display: inline-block;width: 100%">{{itemsq.vc_name}}</span>-->
                            </el-option>

                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                        <el-select v-model="formData.ckname" :placeholder="$t('form_please_select_warehouse')" @change="changeWarehouse" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="one in warehouseName"
                                    :key="one.i_id"
                                    :label="one.vc_name"
                                    :value="one.i_id">
<!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title num" prop="num" label="No:" >
                        <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                    </el-form-item>
                </div>
            <div style="margin-bottom: 20px">
                <el-table
                        border
                        ref="multipleTable"
                        :data="tableData"
                        height="496"
                        class="table"
                        tooltip-effect="dark"
                        style="width: 100%;">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_gsname"
                            :label="$t('form_company')"
                            width="200"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_no"
                            :label="$t('form_batch_number')"
                    width="200"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="kysl"
                            label="可用库存"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="f_num"
                            label="申请出库数量"
                            width="110">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_num'" :rules="formRules.f_num">
                                <el-input  class="changeinput" v-model.number="scope.row.f_num" :disabled="scope.row.i_id!=0" @change="numinput(scope.row)"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_note"
                            label="说明"
                            width="80">
                        <template slot-scope="scope">
                            <el-form-item  class="tableForm-item" :prop="scope.row.vc_note">
                                <el-input class="changeinput" size="mini" v-model="scope.row.vc_note" :disabled="scope.row.i_id!=0"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="center"  width="50">
                        <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1200"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <product-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-details>
                                </template>

                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover>
                            <!--<div class="iconAdd">
                                <span class="add" @click="addOneRow"><i class="el-icon-plus"></i></span>
                            </div>-->
                        </template>
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" >
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">

            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'">保存</el-button>
            <el-button type="primary" @click="toApprove" v-if="state==0" :disabled="disabled" :class="baseerp+'btn'">提交审批</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
            <!--<el-button type="primary" @click="" :disabled="disabled">作废</el-button>
            <el-button type="primary" @click="" :disabled="disabled">中止</el-button>-->
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import ProductDetails from "./ProductDetails";
    export default {
        name: "ApplicationForm",
        components: {ProductDetails},
        props:{
            application:{
                type:Object,
                required:true,
            }
        },
        data(){

            return{
                gsname:"",
                bmname:"",
                sqName:"",
                ckname:"",
                groupid:0,
                formData:{
                    gsname:"",
                    bmname:"",
                    sqName:"",
                    ckname:"",
                    num:"000000",
                    vc_note:"",
                    kysl:"",
                    vc_lruname:"",
                    date:"",
                    tableData:[]
                },
                formRules:{
                    gsname:[{required:true,message:"请选择公司",trigger:"change"}],
                    bmname:[{required:true,message:"请选择部门",trigger:"change"}],
                    sqName:[{required:true,message:"请填写申请人",trigger:"change"}],
                    ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                    f_num:[{required:true,message:"请填写出库量",trigger:"blur"},],
                },

                companyName:[],
                groupName:[],
                personName:[],
                warehouseName:[],
                tableData:[
                ],
                vc_note:"",
                f_num:"",
                visible:false,
                productDetails:{},
                /*beizhuDate:{
                    vc_note:"",
                    vc_lruname:"",
                    date:"",
                },*/
                vc_lruname:"",
                date:"",
                disabled:false,
                isbtn:false,
                edit:false,
                data:{},
                i_id:0,
                state:0,
                qgsname:"",
                qckname:"",
                gsid:0,
                gid:0,
                ckid:0,
                squid:0,
                index:0,
                pageSize:1,
                baseerp:"",
                mid:0,
            }
        },
        watch:{
            application:{
                handler:function (val) {
                    this.i_id=val.i_pid;
                    this.mid=val.i_mid;
                    this.pageSize=val.page_size;
                    //console.log("----i_id--------",this.i_id)
                },
                deep:true,
            }
        },
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.application,"-----------")
            this.i_id=this.application.i_pid;
            this.mid=this.application.i_mid;
            this.pageSize=this.application.page_size;
            this.productDetails.i_mid=this.mid;
            if (this.i_id==0){
                this.edit=false;
                this.getCompanyList();
                this.getGroupList();
                this.getWarehouseList();
                this.getDateYYYYMMddHHMMSS();
            }else {
                this.edit=true;
                this.getPickingList();
            }
        },
        methods:{
            async getPickingList(){
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                };
                let res=await API.getPickingList(param);
                if(res.code==1){
                    let data=res.data;
                    this.formRules={};
                    this.formData={
                        gsname:data.vc_outgsname,
                        bmname:data.outgidname,
                        sqName:data.vc_squname,
                        ckname:data.vc_outckname,
                        num:data.i_id,
                        vc_note:data.vc_note,
                        vc_lruname:data.vc_lruname,
                        date:data.dt_createtime,
                        tableData:data.details,
                    };
                    this.state=data.i_state;
                    this.tableData=data.details;
                    this.gsid=data.i_outgsid;
                    this.gid=data.i_outgid;
                    this.squid=data.i_squid;
                    this.sqName=data.vc_squname;
                    this.i_lruid=data.i_lruid;
                    this.i_lruname=data.i_lruname;
                    this.ckid=data.i_outckid;
                    this.productDetails.gsid=data.i_outgsid;

                    this.productDetails.ckid=data.i_outckid;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                    i_type:"0,1"
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    this.companyName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(){
                let param={
                    i_mid: this.mid,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getPersonList(groupid){
                let param={
                    i_groupid:groupid,
                };
                let res=await API.getPersonList(param);
                if(res.code==1){
                    this.personName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getWarehouseList(){
                let param={
                    i_mid: this.mid,
                };
                let res=await API.getWarehouseList(param);
                if(res.code==1){
                    this.warehouseName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            changeCompany(val){
                //console.log("--gsis",val)
                this.productDetails.gsid=val;
                this.gsid=val;
                let  title="公司";
                this.selectTraderType(title);
            },
            changeWarehouse(val){
                //console.log("--ckis",val)
                this.productDetails.ckid=val;
                this.ckid=val;
                let title="仓库";
                this.selectTraderType(title);
            },
            changeGroup(groupid){
                //console.log(groupid,"======")
                this.formData.sqName='';
                this.squid='';
                this.sqName='',
                this.gid=groupid;
                if (groupid??''!==''){
                    this.getPersonList(groupid);
                }

            },
            changePerson(perid){
                if (perid??''!=='') {
                    this.squid = perid;
                    let obj = this.personName.find(item => item.i_id == perid);
                    this.sqName = obj.vc_name;
                }
            },
            //设置产品联动
            selectTraderType(value){
                if (this.formData.tableData.length==0){
                    this.qgsname=this.formData.gsname;
                    this.qckname=this.formData.ckname;
                    //console.log("--qgsname---",this.qgsname)
                }else if (this.formData.tableData.length>0){
                    this.$confirm(`若是更换${value}会清空列表,是否继续?`,'提示',{
                        confirmButtonText:'确定',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(()=>{
                        this.formData.tableData=[];
                        this.tableData=[];
                    }).catch(()=>{
                        if (value=="公司"){
                            this.formData.gsname=this.qgsname;
                        }else if (value=="仓库"){
                           this.formData.ckname=this.qckname;
                        }
                    })
                }

            },

            numinput(value){
                if (value.f_num>value.kysl) {
                    value.f_num=value.kysl;
                    this.$message.error("申请出库量应小于可用库存");
                    return false
                }
            },
            popShow(){
                //console.log(this.visible)
                if (this.formData.gsname==''||this.formData.ckname==''){
                    this.$message.error("请选择公司或仓库")
                    return
                }else if(this.formData.gsname!=''&&this.formData.ckname!=''){
                    this.visible=true;
                }
                if (this.visible==true){
                    this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            //产品列表
            transValue(value){
                //console.log(value,"------------")
                let arr=[...this.formData.tableData,...value];
                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_pzid+"/"+next.vc_no+"/"+next.i_scid] ? '' : hash[next.vc_pzid+"/"+next.vc_no+"/"+next.i_scid] = true && item.push(next);
                    return item
                }, []);
                this.formData.tableData=arr;
                 this.tableData=arr;
                //console.log("**arr**",newArr3)
            },
            async delPickingList(pid){
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    i_pid:pid,

                };
                let res=await API.delPickingList(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.tableData.splice(this.index,1);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            deleteRow(value,index){
                this.index=index;
                if (value.i_id!=0){
                    this.$confirm('是否删除已保存产品','提示',{
                        confirmButtonText:'确定',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(async()=>{
                        this.delPickingList(value.i_id);

                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消删除'
                        })
                    })
                }else{
                    this.tableData.splice(this.index,1);
                    this.$message.success("删除成功");
                }
               // console.log(value,"-----")
            },
            //提交审批
            toApprove(){
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close',this.pageSize);

                //this.$emit('getPickingReqList')
            },
            //保存
           async saveForm(){
                if (this.squid==''){
                    this.$message.error("请填写申请人");
                    return
                }
                if (this.tableData.length==0){
                    this.$message.error("请添加产品");
                    return
                }
               //console.log(this.tableData,"------")
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    i_outgsid:this.gsid,
                    i_outgid:this.gid,
                    i_outckid:this.ckid,
                    i_squid:this.squid,
                    vc_squname:this.sqName,
                    vc_note:this.formData.vc_note,
                    //i_lruid:this.i_lruid,
                    // i_lruid:42,
                    // vc_lruname:" zyh",
                    // vc_lruname:this.formData.vc_lruname,
                    details:this.formData.tableData,
                };
                let res=await API.savePickingList(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.disabled=true;
                    this.visible=false;
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            }
        },
    }
</script>

<style lang="scss" >
    .flex{
        display: flex;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }
    .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    .table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
    }
    /deep/{
        .table {
            .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
                margin-bottom: 0px;
            }
        }
        .el-table td,.el-table td, .el-table th {
            padding: 10px 0;
        }
        .el-input__inner {

            height: 24px;
            line-height: 24px;

        }
    }
</style>
